import React from 'react';
import { Heading } from '@spothero/ui';
const InOut = ({ inOut }) => {
    if (!inOut) {
        return;
    }
    const inOutAllowed = inOut.allowed;
    return (<Heading color="text.secondary.light" fontSize="sm" fontWeight="normal" mt={2}>
            In/Out {!inOutAllowed ? 'NOT allowed' : 'Privileges '}
            {inOutAllowed === 'yes_fee' || inOutAllowed === 'yes_limited_fee'
            ? 'with Access Fee'
            : null}
        </Heading>);
};
export default InOut;
